import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { Locale } from "@/lib/i18n/config";
import { BackButton } from "@/shared/layout/BackButton";
import { ThemeCreateForm } from "../components/ThemeCreateForm";
import { SectionCard } from "@a2z/ui";

type ThemeCreatePageProps = {
  locale: Locale;
};

export function ThemeCreatePage({ locale }: ThemeCreatePageProps) {
  const t = useTranslations();

  return (
    <section className="flex w-full max-w-2xl flex-col gap-5 lg:px-6 lg:py-6">
      <BackButton
        label={t(keys.common.back)}
        fallbackHref={`/${locale}/admin/themes`}
      />
      <SectionCard title={t(keys.themes.newTitle)}>
        <ThemeCreateForm locale={locale} />
      </SectionCard>
    </section>
  );
}
